/* eslint-disable sonarjs/no-duplicate-string */
const enDictionary = {
  translation: {
    Найти: 'Search',
    'ГСЖ, с': 'S.life, from',
    'ГСЖ, по': 'S.life, to',
    'ГСЖ дни': 'Shelf life days',
    ГСЖ: 'Please fill in guaranteed shelf life of the product. Please, note that it must be at least 2/3 of the product shelf life after delivery of the product.',
    Логин: 'Login',
    Пароль: 'Password',
    'Восстановление пароля': 'Please, enter your login to get the password recovery link.',
    'Ваш логин': 'Your login',
    'Ссылка устарела': 'Link you followed has expired. Please, request a new recovery link.',
    Войти: 'Sign in',
    'Забыли пароль?': 'Forgot your password? Click',
    Восстановить: 'here',
    Офферы: 'Offers',
    Торги: 'Offers',
    Поставщик: 'Supplier',
    'RVI Менеджер': 'RVI MANAGER',
    'КМ ТС Менеджер': 'КМ ТС MANAGER',
    Финанализ: 'FINANCIER',
    Товары: 'Products',
    'Текущая торговая неделя': 'Current week',
    Поиск: 'Search',
    Заказчик: 'Customer',
    Активен: 'Active',
    Неактивен: 'Inactive',
    Финкод: 'Fincode',
    Код: 'Code',
    'Финкод PLU': 'Product category',
    УИ4: 'UI4',
    PLU: 'PLU',
    Этап: 'Stage',
    'Товар (RU)': 'Name (RU)',
    'Товар (EN)': 'Name (ENG)',
    'Коробок/мешков': 'Boxes count',
    'Укажите кол-во кор/мешков': 'Enter boxes count',
    'Паллет на машине/контейнере': 'Pallets count',
    'Укажите кол-во паллет': 'Enter pallets count',
    'Параметры программы - Поставщик': 'Program options - Supplier',
    'Параметры программы': 'Program options',
    'Условия доставки': 'Shipping terms',
    'Параметры PLU': 'PLU parameters',
    'Название или номер PLU': 'Product name or PLU',
    'Выберите статус': 'Select status',
    'Моя валюта': 'My currency',
    Период: 'Period',
    'Календарь поставок': 'Supply calendar',
    Развернуть: 'Expand',
    'Развернуть все': 'Expand all',
    Свернуть: 'Hide',
    'Свернуть все': 'Hide all',
    Нетто: 'Net weight',
    Брутто: 'Gross weight',
    Вес: 'Weight',
    'Кол-во машин': 'Number of shipping units',
    Минимальная: 'Minimum',
    Требуемый: 'Required',
    Предлагаемый: 'Proposed',
    Таргет: 'Target',
    'Макрорегион, город': 'Macroregion, city',
    Моя: 'My',
    Калибр: 'Size',
    'Квант, кг/шт': 'Quant (kg/pcs)',
    Цена: 'Price',
    Фильтры: 'Filters',
    'Начало - конец': 'Start - end',
    'Количество офферов': 'Offers total',
    'Общий объем': 'Total volume',
    Аукцион: 'Auction',
    Программы: 'Programs',
    Статус: 'Status',
    Штрихкод: 'Barcode',
    неизвестно: 'none',
    'нет данных': 'no data',
    'не назначена': 'none',
    'Новый оффер': 'NEW',
    Оффер: 'Offer',
    'Первая цена': 'First price',
    'Предложение цены - за кг/шт': 'Your price (kg/pcs)',
    'Цена от RVI': 'X5 price',
    'Утверждённая цена': 'Last price',
    'Создать оффер': 'Create offer',
    'Страна отправления': 'Country of shipment',
    'Страна происхождения': 'Country of origin',
    'Регион отправления': 'Region of shipment',
    Доставка: 'Transport',
    Сорт: 'Variety',
    Класс: 'Class',
    неделя: 'week',
    год: 'year',
    'Предлагаемый объем (шт/кг)': 'Offered volume (pcs/kg)',
    'Вес нетто (машина/контейнер), кг': 'Net weight (per truck/container), kg',
    'Вес брутто (машина/контейнер), кг': 'Gross weight (per truck/container), kg',
    'Вес нетто': 'Net weight',
    'Вес нетто, кг': 'Net weight, kg',
    'Вес брутто, кг': 'Gross weight, kg',
    'Вес брутто': 'Gross weight',
    'Всего строк': 'Rows total',
    'Показывать по': 'Rows per page',
    'Неделя отгрузки ПЛАН': 'Week of loading PLAN',
    'Неделя прихода в порт ПЛАН': 'Week of arrival PORT PLAN',
    'Неделя прихода ХАБ/РЦ': 'Week of arrival DC PLAN',
    'Дата отгрузки': 'ETD PLAN FROM',
    'Дата прихода в порт/свх': 'ETA PORT PLAN TO',
    'Дата прихода РЦ/ХАБ': 'ETA DC PLAN',
    'Кол-во коробок': 'Boxes/sacks total ',
    'Кол-во паллет на машину/контейнер': 'Pallets per truck/container',
    'Коробок на паллете': 'Boxes per pallet',
    'Кол-во контейнеров/машин': 'Number of shipping units',
    'Материал упаковки': 'Packing material',
    'Тип укладки': 'Packing type',
    'Город ХАБ/РЦ': 'Entry point of arrival/DC',
    Город: 'City',
    Объем: 'Vol',
    'Таможенный пункт входа': 'Customs entry point',
    Комментарии: 'Comments',
    Отправить: 'SEND',
    'До завершения осталось': 'Stage ends in',
    д: 'd',
    ч: 'h',
    мин: 'm',
    сек: 's',
    Назад: 'Back',
    Отменить: 'Cancel',
    'текст сообщения': 'type your message here',
    Нет: 'No',
    'Доставка на ХАБ/РЦ': 'Delivery at entry point/DC',
    'Точка доставки': 'Delivery point',
    'Дата прихода на ХАБ/РЦ': 'Date of arrival at entry point/DC',
    Объём: 'Vol',
    Объем_full_name: 'Volume',
    'Цена на РЦ': 'Price for DC',
    Валюта: 'Currency',
    Менеджер: 'Manager',
    Себестоимость: 'Cost price',
    'Себестоимость (руб)': 'Cost price RUB',
    'Вы вошли как': 'Logged as',
    'Оффер создан': 'Offer created',
    'Оффер обновлен': 'Offer updated',
    'Комментарий отправлен': 'Comment sent',
    'Цена КА Поставщик': 'My price',
    'Цена КА': 'KA Price',
    'Цена RVI': 'RVI Price',
    Сохранить: 'Save',
    Ответить: 'Reply',
    Комментарий: 'Comment',
    size: 'Size',
    selected_size_english_title: 'Size',
    status: 'Status',
    quantum: 'Quantum',
    variety: 'Variety',
    selected_variety_english_title: 'Variety',
    currency: 'Currency',
    hub_price: 'Hub price',
    rvi_price: 'Rvi price',
    net_weight: 'Net weight',
    boxes_count: 'Boxes count',
    first_price: 'First price',
    gross_weight: 'Gross weight',
    freight_price: 'Freight price',
    pallets_count: 'Pallets count',
    product_class: 'Product class',
    delivery_terms: 'Delivery terms',
    offered_volume: 'Offered volume (pcs/kg)',
    packaging_type: 'Packaging type',
    supplier_price: 'Supplier price',
    transport_mode: 'Transport mode',
    rc_moscow_price: 'Rc moscow price',
    transport_count: 'Transport count',
    packing_material: 'Packing material',
    origin_country_id: 'Origin country',
    origin_country: 'Origin country',
    exporting_region_id: 'Exporting region',
    exporting_region: 'Exporting region',
    exporting_country_id: 'Exporting country',
    exporting_country: 'Exporting country',
    customs_entry_point_id: 'Customs entry point',
    customs_entry_point: 'Customs entry point',
    expected_units_quantity: 'Containers count',
    freight_lilo_conditions: 'Freight lilo conditions',
    entry_city_of_arrival_id: 'Entry city of arrival',
    entry_city_of_arrival: 'Entry city of arrival',
    etd_planned: 'ETD PLAN FROM',
    created_at_year: 'Сreated at year',
    etd_planned_week: 'Week of loading PLAN',
    port_eta_planned: 'ETA PORT PLAN TO',
    port_eta_planned_week: 'Week of arrival PORT PLAN',
    dc_eta_planned_week: 'Week of DC ETA PLAN',
    dc_eta_planned: 'DC ETA PLAN FROM',
    'ХАБ/РЦ': 'HUB/DC',
    'Высокая цена': 'High price',
    'Превышает потребность': 'Exceeds demand',
    'Не соответствует стандартам': 'Out of standard',
    'Закрыта карточка': 'Demand is covered',
    'Не устраивает логистика': 'Logistics does not suit',
    Активность: 'Actions',
    'Изменения по офферу': 'Changes',
    Изменения: 'Changes',
    'Изменил(а) параметр': 'Changed',
    'Предыдущее значение': 'from',
    'Новое значение': 'to',
    price: 'Price for DC',
    volume: 'Volume',
    week_planned: 'Week of arrival DC PLAN',
    'Добавил(а)': 'Added',
    'Создал оффер': 'Created offer',
    'Добавил(а) комментарий': 'Added comment',
    'Курс валюты': 'Excange rate',
    'Параметры товара': 'Characteristics',
    Упаковка: 'Pack',
    Даты: 'Dates',
    'Стоимость фрахта': 'Freight price',
    'Укажите стоимость 1 ед товара': 'Please, fill in your price per 1 unit (kg/pcs) of offered product',
    'Укажите общий (в кг/шт) предлагаемый объём товара (не кол-во транспортных единиц)':
      "Please, fill in total offered volume of the product (in kg/pcs)  you're offering (not the number of trucks, containers or else)",
    'Укажите цены на те точки, на которые Вы готовы везти предлагаемый объём':
      "Please, fill in your prices for DAP locations at which you're able to deliver offered volume",
    'Событий (3+) еще': 'Events: (3+) show',
    preorder: 'Preorder',
    created: 'Created',
    creating_failed: 'Creating failed',
    cancelled: 'Cancelled',
    'Доступный объем': 'Available volume',
    'Доступный объем (шт/кг)': 'Available volume (pcs/kg)',
    'Объем (шт/кг)': 'Total volume (kg/pcs.)',
    'Валюта оффера': 'Offer currency',
    'обязательное поле': 'Required field',
    Неделя: 'Week',
    price_by_unit: 'Price by unit',
    pcs: 'pcs',
    kg: 'kg',
    l: 'l',
    'Введите новый пароль': 'Enter new password',
    'Используйте заглавные и строчные буквы, цифры, минимум 8 символов':
      'Use upper and lower case letters, numbers, at least 8 characters',
    'Повторите пароль': 'Repeat password',
    'Ваша учётная запись была деактивирована. Обратитесь к менеджерам X5.':
      'Your account has been disabled. Please, contact your X5 manager.',
    'Новый пароль': 'New password',
    'Неправильный логин или пароль!': 'Incorrect login or password!',
    экспорт: 'export',
    'Нашли ошибку? Eсть предложения по улучшению? Напишите нам':
      'In case of problems or suggestions, please contact us',
    Действия: 'Actions',
    Шаблоны: 'Templates',
    'Применить шаблон': 'appply template',
    Закрыть: 'Close',
    Новый: 'New',
    'Шаблонов к данному продукту пока нет': 'Templates for this product are yet unavailable',
    Название: 'Name',
    'Сохранить шаблон': 'Save template',
    'Создать шаблон': 'Create template',
    'Вы уверены?': 'Are you sure you want to DELETE this offer?',
    Да: 'Yes',
    Отмена: 'Cancel',
    Применить: 'Apply',
    Подтвердить: 'Apply',
    'Выберите заказчика': 'Select customer',
    'Мин значение': 'Min value is',
    'Макс значение': 'Max value is',
    'Номер недели': 'Week number',
    Категория: 'Category',
    'ID оффера': 'Offer ID',
    'ID микса': 'Mix ID',
    'ID Аукциона': 'Auction ID',
    'Товар (RUS)': 'Product (RUS)',
    'Товар (ENG)': 'Product (ENG)',
    Баркод: 'Barcode',
    'Предложенный объем': 'Offered volume',
    'Год создания': 'Created at year',
    'Цена на ХАБ/РЦ': 'On hub price',
    'Цена на РЦ МСК': 'On dc moscow price',
    'Дата прихода на РЦ': 'Dc ETA planned',
    'Неделя прихода ПЛАН': 'Week of arrival PLAN',
    'Цена от поставщика': 'Supplier price',
    'Количество контейнеров': 'Containers count',
    Единица: 'Unit',
    Выгрузка: 'Export',
    Загрузка: 'Import',
    'Загрузка..': 'Loading..',
    Микс: 'mix',
    'Собрать микс': 'Create mix',
    'Редактировать микс': 'Edit mix',
    'Код в SAP': 'SAP code',
    'Код SAP': 'SAP code',
    Страна: 'Country',
    Имя: 'Name',
    Фамилия: 'Last name',
    Компании: 'Companies',
    Пользователи: 'Users',
    'Номер телефона': 'Phone',
    Тэги: 'Tags',
    'Краткое название': 'Short name',
    Заказы: 'Orders',
    Поставщики: 'Suppliers',
    'Выбрано офферов': 'Selected offers',
    'Цена за единицу': 'Price per unit',
    Курс: 'Rate',
    'Неделя погрузки ПЛАН': 'Expected week of shipping',
    'Неделя прихода в порт (план)': 'Week of arrival PORT PLAN',
    'Неделя прихода на ХАБ/РЦ ПЛАН': 'Week of arrival DC PLAN',
    'Дата погрузки': 'ETD PLAN FROM',
    'Дата прихода в порт': 'ETA PORT PLAN FROM',
    'Причина отказа': 'Refusal reason',
    'Есть комментарии': 'Has comments',
    Торгуется: 'Trading',
    'На согласовании': 'Waiting for approval',
    Согласован: 'Approved for order',
    Отклонен: 'Refused',
    Истёк: 'Expired',
    'Сбросить фильтры': 'Reset filters',
    'Approved for order': 'Approved for order',
    Trading: 'Trading',
    'Demand is covered': 'Demand is covered',
    'Exceeds demand': 'Exceeds demand',
    Expired: 'Expired',
    False: 'False',
    'High price': 'High price',
    'Logistics does not suit': 'Logistics does not suit',
    'Out of standard': 'Out of standard',
    Refused: 'Refused',
    'Selected for approval': 'Selected for approval',
    True: 'True',
    'Waiting for approval': 'Waiting for approval',
    null: 'Empty',
    status_decline: 'Status decline',
    status_ok: 'Status ok',
    status_waiting: 'Status waiting',
    'Статус оффера': 'Offer status',
    'Должна быть >= текущей дате': 'Must be >= to current date',
    'Должна быть > даты отгрузки': 'Must be > than ETD PLAN',
    'Должна быть >= дате прихода в порт': 'Must be >= to ETA PORT PLAN',
    'Ваш менеджер': 'Your manager',
    Телефон: 'Phone',
    'Введите сорт': 'Enter variety',
    'Выберите страну': 'Choose country',
    'Выберите регион': 'Choose region',
    'Выберите условия поставки': 'Select delivery terms',
    'Выберите пункт входа': 'Select entry point',
    'Выберите пункт': 'Select entry point',
    'Выберите город': 'Choose city',
    'Выберите способ доставки': 'Choose a shipping method',
    'Способ доставки': 'Shipping method',
    'Условия поставки': 'Delivery terms',
    'Выберите материал': 'Select material',
    'Выберите тип укладки': 'Choose the type of styling',
    'Выберите тип': 'Select packaging type',
    passwordErrWide: 'Your password is too popular.',
    passwordErrShort: 'This password is too short. It must contain at least 8 characters.',
    passwordErrDigitsOnly: 'Your password must contain numbers and letters! Try again.',
    passwordErrWordsOnly: 'Your password must contain numbers and letters! Try again.',
    passwordNameEqual: 'Password is too similar to the first name! Try again.',
    passwordLoginEqual: 'Password is too similar to the username! Try again.',
    passwordLastNameEqual: 'Password is too similar to the users last name! Try again.',
    passwordEmailEqual: 'Password is too similar to email! Try again.',
    // 'W ETD': 'Expected week of loading',
    // 'W ETA': 'Expected week of arrival',
    // 'W ETA DC': 'Expected week of delivery',
    // 'ETD': 'Expected date of loading',
    // 'ETA PORT': 'Expected date of arrival',
    // 'ETA DC': 'Expected date of delivery',
    'W ETD Filter': 'W ETD',
    'W ETA Filter': 'W ETA',
    'W ETA DC Filter': 'W ETA DC',
    'ETD Filter': 'ETD',
    'ETA PORT Filter': 'ETA PORT',
    'ETA DC Filter': 'ETA DC',
    Миксы: 'Mixed orders',
    Макрорегион: 'Macroregion',
    Активировать: 'Activate',
    Деактивировать: 'Deactivate',
    Удалить: 'Delete',
    'Добавить поставщика': 'Add supplier',
    user_is_inactive: 'Your account is deactivated. Please, contact your manager for more info.',
    resetting_password_denied: 'There is no active account. Contact your manager.',
    resetting_password_empty: 'This field cannot be empty.',
    Заказать: 'Make an order',
    'Не устраивают тайминги': 'Timings does not suit',
    'Timings does not suit': 'Timings does not suit',
    'ГСЖ дни тултип':
      'Please fill in guaranteed shelf life of the product in days. Please, note that it must be at least 2/3 of the product shelf life after delivery of the product. Shellife counts from date ETD PLAN FROM automatically.',
    Нед: 'Wk',
    январь: 'january',
    февраль: 'february',
    март: 'march',
    апрель: 'april',
    май: 'may',
    июнь: 'june',
    июль: 'july',
    август: 'august',
    сентябрь: 'september',
    октябрь: 'october',
    ноябрь: 'november',
    декабрь: 'december',
    'Ст проис': 'Orig. cnt.',
    'Ст отпр': 'Ship. cnt.',
    Регион: 'Region',
    'Укажите квант': 'Enter quant',
    'Укажите калибр': 'Enter size',
    'Выберите класс': 'Select class',
    'Укажите сорт': 'Enter variety',
    'Укажите кол-во дней': 'Enter s.life, d',
    'Кол-во коробок на одной паллете': 'Boxes per pallet',
    'Кол-во коробок на машину/контейнер': 'Pallets per truck/container',
    'Кол-во коробок/мешков на машину/контейнер': 'Boxes per truck/container',
    'Единица измерения товара (шт/кг)': 'Measurement unit (pieces or kilos)',
    'Цена предлагаемая RVI поставщику': 'Import price per item',
    'Цена предлагаемая поставщиком RVI': "Supplier's price per item",
    'Курс валют на дату создания офера': 'Currency rate as of the  date of offer creation',
    'Валюта офера': 'Offer currency',
    'Условия поставки INCOTERMS': 'INCOTERMS',
    Таможня: 'Customs',
    'ХАБ/РЦ p': 'DC price',
    'Себестоимость поставки на ХАБ/РЦ в рублях': 'Cost price for HUB/DC in RUB',
    'РЦ МСК p': 'DC MSC price',
    'Себестоимость поставки на РЦ в МСК в рублях': 'Cost price for DC MSC in RUB',
    'Неделя прихода в порт/СВХ ПЛАН': 'Expected week of arrival at customs',
    'Неделя прихода ХАБ/РЦ ПЛАН': 'Expected week of arrival at HUB/DC',
    'Начало гарантированного срока жизни товара':
      'The begining of the shelf life date. Please note, that shelf life must be at least 2/3 of overall shelf life after the product was delivered.',
    'Конец гарантированного срока жизни товара':
      'The end of the shelf life date. Please note, that shelf life must be at least 2/3 of overall shelf life after the product was delivered.',
    'Дата отгрузки ПЛАН': 'Expected date of shipping',
    'Дата прихода в порт/свх ПЛАН': 'Expected date of arrival at customs',
    'Дата прихода РЦ/ХАБ ПЛАН': 'Expected date of arrival at HUB/DC',
    'Сеть заказчик': 'Chain retail customer',
    ТС: 'Customer',
    ТС_tn: 'TN',
    'Предложенный объём': 'Offered volume',
    'Номер, который показывает, что офер находится в миксе и едет в одной машине':
      "MIX ID shows that it's a mix offer and offered volume will be shipped in the same truck as other offers under the same MIX ID",
    Укладка: 'Stacking',
    'ГСЖ д': 'S.life, d',
    'Гарантированный срок жизни товара в днях': 'Shelf life in days',
    'Дата создания': 'Created at date',
    'Точки доставки': 'Delivery points',
    'Цены и точки': 'Delivery points',
    'Параметры точек доставки': 'Delivery points params',
    'Все столбцы': 'All params',
    Сбросить: 'Reset',
    копировать: 'copy',
    'удалить пресет': 'remove preset',
    сохранить: 'save',
    'добавить пресет': 'add preset',
    'Неделя прихода на ХАБ/РЦ': 'Week of arrival DC',
    Год: 'Year',
    Дата: 'Date',
    'Программа удалена': 'The program has been deleted',
    'Программа подтверждена': 'The program is confirmed',
    'Параметры оффера': 'Offer details',
    Параметры: 'Details',
    approved_by_tn: 'Approved by TN',
    approved_by_tn_to_run: 'Approved by TN to run',
    on_approval: 'On approval',
    new: 'New',
    'Не заданы цены на точки доставки': 'Fill price for delivery points',
    Создать: 'Create',
    'Список офферов': 'List of offers',
    'Программные офферы': 'Program offers',
    'Точки и даты доставки': 'Delivery points and dates',
    по: '-',
    с: '',
    'Ожидает запуска': 'Waiting for start',
    'Моих предложений': 'My offers',
    'Выбрано предложений': 'My offers selected',
    Деактивирована: 'Deactivated',
    'Для подачи оффера необходимо заполнить все обязательные поля отмеченные звездочкой во вкладке “Параметры” и указать цену во вкладке “Цены и точки”':
      'To submit an offer, please fill in all the required fields marked with an asterisk in the “Details” tab and specify the price in the “Delivery points” tab',
    'Валюта фрахта': 'Freight currency',
    'Вы увидите желаемую цену после заполнения всех условий поставки в строке':
      'You’ll see the target price after filling in all the offer details in the line',
    'Выберите параметры для разных условий поставки': 'Сhoose options for different delivery terms:',
    'Этап аукциона остановлен': 'The auction stage has been stopped',
    Остановить: 'Stop stage',
    'Произошла ошибка': 'An error has occurred',
    'Этап аукциона успешно удален': 'The auction stage has been successfully deleted',
    'Погрузочно-разргрузочные работы при фрахте': 'Loading and unloading of the cargo in the freight rate',
    'Список значений': 'List of values',
    ПРР: 'Loading/Unloading',
    shipping_terms: 'Loading/Unloading',
    refusal_reason: 'Refusal reason',
    auction_stage_progress1_tooltip: '*Total suggested volume vs. total required volume in the program',
    auction_stage_progress2_tooltip:
      '*Total suggested volume corresponding to target prices vs. total required volume in the program',
    auction_stage_circlebar1_tooltip:
      '*Suppliers who submitted at least one offer vs. total number of suppliers in the stage',
    auction_stage_circlebar2_tooltip:
      '*Number of offers that have reached the target price vs. total number of submitted offers',
    кг: 'kg',
    cancelAuctionDescription:
      'Cancellation of the auction will result in the cancellation of all offers in all stages of the auction. Participating suppliers will receive a notification about this. All offers will be marked as cancelled.',
    'Аукцион отменен': 'Auction cancelled',
    'Укажите причину отмены': 'Specify the reason for cancellation',
    'Укажите причину': 'Specify the reason',
    Завершить: 'Complete',
    'Завершить аукцион': 'Complete the auction',
    compeleteAuctionDescription:
      'Early completion of the auction will lead to the fact that all the planned but not yet started stages of the auction will be canceled. \n\n Suppliers will receive notifications with the current auction results. \n\n The program will be formed from the set of offers that were collected in the current state of the auction.',
    'Аукцион завершен': 'Auction completed',
    Возобновить: 'Resume',
    'Воозобновить этап': 'Resume stage',
    'Этап аукциона возобновлен': 'The auction stage has been resumed',
    restartAuctionStageDescription:
      'Are you sure you want to resume the stage? The start of the stage will send an e-mail notification to the participating suppliers. All offers of participants will be transferred to the status "under consideration".',
    Признак: 'Badge',
    БУСИ: 'BUSI',
    УСИ: 'USI',
    'Вес нетто коробки': 'Net weight of the box',
    'Минимальное значение': 'Min value',
    'Максимальное значение': 'Max value',
    ВЕРСИЯ: 'VERSION',
    Инструкции: 'Manuals',
    'Редактирование информации о товаре': 'Change product information',
    'Отправить в тс': 'Send to ts',
    Согласовать: 'Approve',
    'Офферы не соответствуют требованиям': 'Offers do not meet the requirements',
    'Офферы согласованы': 'Offers approved',
    'Оффер согласован': 'Offer approved',
    Согласовано: 'Approved',
    'Только торгующиеся офферы с признаком БУСИ': 'Only trading offers with BUSI sign',
    'Только торгующиеся офферы с признаком УСИ': 'Only trading offers with USI sign',
    Загрузить: 'Import',
    Выгрузить: 'Export',
    'Отправить на почту': 'Send by email',
    Принять: 'Accept',
    Отклонить: 'Reject',
    'Не доступно': 'Is not available',
    'Найдено аукционов': 'Auctions found',
    '№ Аукциона': '№ Auction',
    'Дата изменения': 'Date of change',
    Создана: 'Created at',
    Начало: 'Start',
    Окончание: 'End',
    Сроки: 'Deadlines',
    'Введите себестоимость в рублях': 'Enter the cost price in rubles',
    Все: 'All',
    'Список программ': 'Program list',
    Новая: 'New',
    'Согласовано ТС к старту': 'Approved by TN',
    not_approved_by_tn: 'Not approved by TN',
    not_approved_by_tn_to_run: 'Not approved by TN to run',
    auction_going_on: 'Auction in progress',
    auction_completed: 'Auction completed',
    running: 'Running',
    finished: 'Finished',
    Отменена: 'Сancelled',
    paused: 'Paused',
    Программа: 'Program ID',
    'Себестоимость в рублях': 'Price in rubles',
    Заказ: 'Order',
    'Статус заказа': 'Order status',
    'Суммарный объем': 'Full ordered volume',
    Сеть: 'Chain',
    'Наименование товара (RUS)': 'PLU name (RUS)',
    'Цена на ХАБ': 'Price for HUB',
    'Неделя прихода РЦ/ХАБ ПЛАН': 'Planned week of arrival at HUB/DC',
    'Неделя погрузки ФАКТ': 'ETD fact week',
    'Неделя прихода в порт/свх ФАКТ': 'Port ETA fact week',
    'Неделя прихода ХАБ/РЦ ФАКТ': 'DC ETA fact week',
    'Дата отгрузки ФАКТ': 'ETD fact',
    'Дата прихода в порт/свх ФАКТ': 'Port ETA fact',
    'Дата прихода РЦ/ХАБ ФАКТ': 'DC ETA fact',
    'Мои Шаблоны': 'Templates',
    'Мои шаблоны': 'Templates',
    'У Вас нет сохраненных шаблонов': 'You don`t have any saved templates',
    tooltipCreateTemplate:
      'You can create a reusable offer template. Fill in the fields that will be saved in the template. You can edit the template at any time.',
    'Название шаблона': 'Template name',
    'Введите название': 'Enter the title',
    'Шаблон создан': 'The template has been successfully created.',
    'Заполните обязательные параметры': 'Fill in the required parameters',
    'Выбрано RVI': 'Accepted by RVI',
    'Недоступно для редактирования': 'Editing unavailable',
    'Признак УСИ/БУСИ': 'Badge USI/BUSI',
    'Торговые недели': 'Trading weeks',
    'Предлагаемый объем': 'Offered volume',
    'Основная информация': 'Basic information',
    'Моя цена': 'My price',
    'Цена поставщика': 'Supplier price',
    'Себестоимость поставщика': 'Supplier cost price',
    'Выбранные фильтры': 'Selected filters',
    'Шаблоны фильтров': 'Filter presets',
    'Сохранить как шаблон': 'Save as template',
    'Найдено офферов': 'Offers found',
    Выбрать: 'Select',
    'Удалить шаблон?': 'Delete template?',
    descriptionModalDeleteTemplateOffer: 'All template parameters will be permanently deleted.',
    'Шаблон удален': 'Tempate deleted',
    Дублировать: 'Duplicate',
    'Создать новый': 'Create new',
    'Шаблон продублирован': 'Template duplicated',
    'Шаблон обновлен': 'Template updated',
    'На машину/контейнер': 'Per truck/container',
    Спецификации: 'Specifications',
    Фрахт: 'Freight',
    'Транспортных ед': 'Number of shipping units',
    Столбцы: 'Columns',
    поиск: 'search...',
    'Создание заказа': 'Created at',
    'id оффера': 'offer id',
    'id программы': 'program id',
    'Ordered volume': 'Volume',
    'W ETA DC (план)': 'W ETA DC (plan)',
    'W ETD (факт)': 'W ETD (fact)',
    'W ETA (факт)': 'W ETA (fact)',
    'W ETA DC (факт)': 'W ETA DC(fact)',
    'с/с': 'Cost price',
    Удален: 'Deleted',
    Отменен: 'Cancelled',
    'Объем программы': 'Program volume',
    'Неделя поставки': 'Delivery week',
    'Точка входа': 'Delivery point',
    'Выполнение программы': 'Program performance',
    'По офферам': 'Offers',
    'По заказам': 'Orders',
    Остановлен: 'Paused',
    Cancelled: 'Cancelled',
    'Оффер отклонен': 'Offer refused',
    Допинформация: 'Additional info',
    product_ui4: 'UI4',
    'Таможенный пункт': 'Customs entry point',
    'Предложение изменено': 'Offer changed',
    'Предложение создано': 'Offer created',
    ФРОВ: 'Fruits&Vegetables',
    НЕФРОВ: 'FMCG',
    nonfrov_coming_kmts:
      'You have registered in the system as an KM TS. We are already working on new functionality, it will appear here soon.',
    nonfrov_coming_rvi:
      'You have registered in the system as an KM RVI. We are already working on new functionality, it will appear here soon.',
    nonfrov_coming_supplier:
      'You have registered in the system as an supplier. We are already working on new functionality, it will appear here soon.',
    'Список хабов': 'HUB List',
    'Список РЦ': 'DC List',
    'Мой Объем': 'My volume',
    'Цена Import': 'Import Price',
    'Объем Import': 'Import Volume',
    'Через ХАБ': 'Via HUB',
    'Моя c/c': 'My cost price',
    'С/С КА': 'KA cost price',
    'Мой объем, шт/кг': 'My volume, pcs/kg',
    'Объем КА, шт/кг': 'KA volume, pcs/kg',
    'Объем Import, шт/кг': 'Import volume, pcs/kg',
    'Ваша цена автоматически приравняется цене Import': 'Your price will automatically be equal to the Import price.',
    'Согласовать оффер?': 'Approve offer?',
    supplier_auction_template_save_tooltip: 'Fill in the parameters for submitting offers of this type of supply',
    supplier_auction_template_text: 'Select options for different delivery conditions:',
    'Коробок/мешков на 1 машине': 'Boxes count per 1 truck',
    'Паллет на 1 машине/контейнере': 'Pallet per 1 truck/container',
    'Коробок на палете 1 машины': 'Boxes on pallet per 1 truck',
    'Значение указывается за одну машину': 'Value is specified for 1 truck',
    'Заполните пожалуйста все поля в условиях поставки':
      'Please fill in all the fields in the current terms of delivery',
    'Оффер №': 'Offer №',
    'Вернуться на страницу авторизации': 'Go back to the authorization page',
    'Инструкция отправлена': 'Instructions have been sent',
    'По возрастанию': 'Sort ascending',
    'По убыванию': 'Sort descending',
    'отметить все': 'choose all',
    'очистить все': 'clear all',
    no_data_found: 'No results were found for your request. Try entering other information',
    'Окончание этапа': 'End of the stage',
    'Название RUS': 'Name RUS',
    'Название ENG': 'Name ENG',
    Проекты: 'Projects',
    'Дата создания проекта': 'Project creation date',
    'Дата начала сбора офферов': 'The start date of the collection of offers',
    'Дата окончания сбора офферов': 'The end date of the collection of offers',
    'Дата окончания проекта': 'Project completion date',
    'Сбросить все': 'Reset everything',
    'Сбор офферов': 'Collecting offers',
    'Выбор офферов': 'Selection of offers',
    'Проект завершён': 'Project is completed',
    'Проект отклонен': 'Project is rejected',
    'На согласовании ТС': 'On approval',
    'Нет добавленных лотов': 'No added lots',
    'Создание проекта': 'Creating a project',
    'Окончание сбора офферов': 'The end of the collection of offers',
    'Завершение проекта': 'Project completion',
    collection: 'Collecting offers',
    selection: 'Selection of offers',
    finish: 'On approval',
    rejected: 'Project is rejected',
    'Найдено проектов': 'Projects found',
    'Из списка': 'From the list',
    'Дата завершения проекта': 'Project completion date',
    projects_not_found_message: 'No results were found for your request. Try entering other information',
    Едизм: 'Unit of measurement',
    'Страна (рус)': 'Country (Rus)',
    'Страна (англ)': 'Country (Eng)',
    'Добавить лот': 'Add lot',
    'Для добавления поставщиков заполните обязательные поля': 'To add suppliers, fill in the required fields',
    'Для добавления лотов заполните обязательные поля': 'To add lots, fill in the required fields',
    'ID лота': 'Lot ID',
    Финкод2: 'Financial code',
    Сеть2: 'Trade Network',
    'Название товара (полное)': 'Product full name',
    'Торговая марка': 'Trade mark',
    'Описание товара': 'Product description',
    'Введите описание': 'Enter the description',
    'Срок производства': 'Production time',
    'Минимальный заказ на 1 SKU': 'MOQ',
    'Представленность в сетях': 'Have you already presented in Russian market and if so where',
    'Файлы оффера': 'Add files',
    'Файл PDF (макс 10мб)': 'PDF File (max 10MB)',
    'Файл Excel (макс 10мб)': 'Excel File (max 10MB)',
    'Фото продукции (макс 10мб)': 'Picture (max 10MB)',
    'Excel-калькулятор (макс 10 мб)': 'Excel-calculator (max 10MB)',
    'Цена за единицу товара': 'Price, Incoterms options',
    'Одно из полей раздела обязательно для заполнения': 'One of the fields in this section is required',
    Логистика: 'Logistics',
    'Код ТН ВЭД': 'HS code',
    'Информация о товаре': 'Product information',
    'Срок годности, мес': 'Shelf life, months',
    'Срок годности после вскрытия, дни': 'Shelf life after opening, days',
    'Масса основного продукта, гр': 'Dry weight, g',
    'Объем (ед), л (для жидкости)': 'Unit volume, L (Drinks, vape)',
    'Полный состав': 'Ingredients',
    'Введите состав': 'Specify ingredients',
    'Укажите условия': 'Specify conditions',
    'Введите значение': 'Enter value',
    'Выберите из списка': 'Enter value',
    'Выбор страны': 'Choose country',
    'Выбор региона': 'Choose region',
    'Упаковка и вес': 'Packaging and weight',
    Общее: 'General',
    'Вес нетто за ед товара, кг': '1 Unit net weight, kg',
    'Вес брутто за ед товара, кг': '1 Unit gross weight, kg',
    'Условия хранения при транспортировке': 'Storage conditions for transportation',
    'SRP шоу бокс': 'SRP showbox',
    'Шоу боксов в коробке': 'Showboxes in 1 box',
    'Кол-во штук в шоу боксе': 'Unit pcs in showbox',
    Коробки: 'Boxes',
    'Вес нетто за 1 коробку, кг': '1 box net weight, kg',
    'Вес брутто за 1 коробку, кг': '1 box gross weight, kg',
    'Кол-во товара в коробке': 'Unit pcs in 1 box',
    'Вместимость коробок': 'Quantity of products which can be uploaded',
    'Вместимость коробок Алко': 'Box capacity',
    'Экспортных коробок в машине': 'Export boxes in truck',
    'Экспортных коробок в контейнере 20': 'Number of pallets in container 20f',
    'Экспортных коробок в контейнере 40': 'Number of pallets in container 40f',
    'Экспортных коробок в контейнере 40 HQ': 'Number of pallets in container 40f HQ',
    'Экспортных коробок в контейнере 45': 'Number of pallets in container 45f',
    Паллеты: 'Pallets',
    'Поставляется на паллетах': 'Delivered on pallets',
    'Вес нетто 1 паллеты, кг': '1 pallet net weight, kg',
    'Вес брутто 1 паллеты, кг': '1 pallet gross weight, kg',
    'Кол-во единиц на 1 паллету': 'Unit pcs in 1 pallet',
    'Кол-во коробок на 1 паллету': 'Boxes in 1 pallet',
    'Вместимость паллет': 'Pallets capacity',
    'Кол-во паллет в машине': 'Number of pallets in truck',
    'Кол-во паллет в контейнере 20': 'Number of pallets in container 20f',
    'Кол-во паллет в контейнере 40': 'Number of pallets in container 40f',
    'Кол-во паллет в контейнере 40HQ': 'Number of pallets in container 40f HQ',
    'Кол-во паллет в контейнере 45': 'Number of pallets in container 45f',
    'Ед изм': 'Unit',
    'Ед изм (кг/шт)': 'Unit',
    Товар: 'Product',
    'Мин цена поставщика': 'Min supplier price',
    Подтвердить2: 'Confirm',
    'Подтвердить удаление?': 'This decision cannot be changed. Confirm deletion?',
    'Удалить оффер': 'Delete offer',
    'Проект отправлен в ТС': 'Project sent to TS',
    'Оффер предварительно выбран менеджером Редактирование невозможно':
      'The offer is pre-selected by the manager. Editing is not possible',
    'Under review': 'Under review',
    'Sent to TN': 'Sent to TN',
    'Refused by RVI': 'Refused by RVI',
    'Rejected by TN': 'Rejected by TN',
    'Agreed by TN': 'Agreed by TN',
    New: 'New',
    Ошибка: 'Error',
    'Запрашиваемая страница не найдена':
      'The requested page was not found. Perhaps, the page was deleted, moved to another location or an error was made while typing URL - address.',
    'У Вас нет доступа к данной странице': 'You are not allowed to acces this page',
    'Вернуться на главную': 'Return to main page',
    Инкотермс: 'Incoterms',
    'КН/ТС Выбранный транспорт': 'Selected Transport (Container/Truck)',
    'Способ доставки нефров': 'Transport mode',
    Хаб: 'Hub',
    'Фрахт авто, EUR': 'Car freight',
    'Фрахт море': 'Sea freight',
    Прокси: 'Proxy',
    Маркировка: 'Marking',
    СТМ: 'Own brand',
    'На шт руб': 'Per piece, RUB',
    'На литр, руб': 'Per liter, RUB',
    'На сахаросодержащие напитки': 'On sugar-sweetend beverages',
    'Доля затрат на доставку до границы, %': 'Share of costs for delivery to the border',
    'Прочие расходы до границы, USD': 'Other expenses to the border, USD',
    'Прочие расходы после границы, RUB': 'Other expenses after the border, RUB',
    'Применить комбинированную ставку пошлины': 'Apply combined duty rate',
    'Себестоимость товара': 'Product cost',
    'Прочие затраты': 'Other costs',
    Акцизы: 'Excise tax',
    'Обязательное поле': 'Required field',
    'Оффер удалён': 'Offer deleted',
    'На рассмотрении': 'Under review',
    'Отправлен в сеть': 'Sent to TN',
    'Отклонен  RVI': 'Refused by RVI',
    loadingClickCancel: 'Loading. Click to cancel',
    photoProductMax10mb: 'Product photo (max 10MB)',
    excelMax10mb: 'Excel File (max 10MB)',
    pdfMax10mb: 'PDF File (max 10MB)',
    theFileIsTooLarge: 'The file is too large. Select a file less than 10Mb',
    'Отклонен ТС': 'Rejected by TN',
    'Согласован ТС': 'Agreed by TN',
    'Расчет себестоимости': 'Cost calculation',
    'Выберите файл меньше 10Мб': 'Select a file smaller than 10Mb',
    'успешно создан': 'has been successfully created',
    'успешно сохранен': 'has been successfully saved',
    'Тип выдержки': 'Type of aging',
    'Тип стекла': 'Type of glass',
    'Обьем единицы товара, л': 'Volume per unit, lt',
    'Крепость, %': 'Alcohol, %',
    'Уровень сахара г/л': 'Sugar level gr/lt',
    'Высота короба, мм': 'Box height, mm',
    'Ширина короба, мм': 'Box width, mm',
    'Глубина короба, мм': 'Box depth, mm',
    'Вес короба брутто, кг': 'Box gross weight, kg',
    'Бутылок на паллете': 'Bottles per pallet',
    'Коробов на паллете, шт': 'Box per pallet',
    'Вес паллеты нетто, кг': 'Pallet weight net, kg',
    'Вес палетты брутто, кг': 'Pallet weight gross, kg',
    'Объем поставки, паллеты': 'Pallets scope',
    'Вы действительно хотите удалить файл?': 'Are you sure you want to delete the file?',
    'Потребность (шт)': 'Demand (pcs)',
    Потребность: 'Demand',
    'Создать потребность': 'Create demand',
    Лоты: 'Lots',
    'Заполните валюту и как минимум одну из цен на желаемое условие поставки':
      'Fill in the currency and one or more prices for the desired delivery conditions',
    'Вес нетто 1 коробки/Кол-во штук в 1 коробке': 'Net weight of 1 box/Number of pieces in 1 box',
    'Загружено файлов': 'Uploaded files',
    'Дата окончания этапа': 'Stage end date',
    'Разместить оффер': 'Make an offer',
    'Название (RUS)': 'Name RUS',
    'Название (ENG)': 'Name ENG',
    'Ставка НДС, %': 'VAT rate, %',
    'Специфическая ставка, %': 'Specific rate, %',
    'Preference the ad valorem rate': 'Preferential valorem rate, %',
    'Preference specific rate': 'Preferential specific rate, %',
    'Адвалорная ставка, %': 'Valorem rate, %',
    unitPcsInOneBox: 'Quantity of goods in 1 box',
    'Пример: AOP Bordeaux сухое красное': 'Example: AOP Bordeaux DRY RED',
    'Пример: CHATEAU st. Alex et Marie': 'Example: CHATEAU st. Alex et Marie',
    'Пример: красное сухое вино Cabernet Sauvignon, Merlot': 'Example: Red Dry Wine Cabernet Sauvignon, Merlot',
    'Пример: 30% Barrels Aging 12 months/100% Aging on the Lees for 12 months':
      'Example: 30% Barrels Aging 12 months/100% Aging on the Lees for 12 months',
    'Найдено потребностей': 'Demands found',
    'успешно сохранена и отправлена RVI': 'successfully saved and sent to RVI',
    'Регулярные потребности': 'Reg. demands',
    demand_product_ts: 'File TS',
    demand_product_presentation: 'Presentation',
    demand_product_picture: 'Photo',
    demand_product_other: 'Other',
    ocp_excel_file_calculator: 'File Calculator',
    'Тип упаковки': 'Type of packaging',
    'Срок производства упаковки, дни': 'Packaging production time, days',
    'Срок производства заказа, дни': 'Order production time, days',
    'Квант (кг/шт)': 'Quantum (kg/pcs)',
    'Вес нетто за ед товара': '1 Unit net weight, kg ',
    'Вес брутто за ед товара': '1 Unit gross weight, kg ',
    'SRP шоубокс': 'SRP showbox',
    own_trademark: 'Private label',
    total_demand: 'Total demand',
    local_demand: 'Local demand',
    is_busi_True: 'BUSI',
    is_busi_False: 'USI',
    regular_demands_not_found_message: 'Nothing found on your request. Enter other information',
    'Ед измерения': 'Unit',
    'Объем (машина/контейнер)': 'The volume (truck/container)',
    'Объем (машина/контейнер) кг/шт': 'The volume (truck/container) kg/pcs',
    'Ошибка Квант': 'The quantum must be an integer for a countable product and a fraction for a measurable product.',
    'При отсутствии нужного значения в списке обратитесь к менеджерам RVI':
      'If the value is not on the list, contact RVI managers',
    'Вес упаковки, кг': 'Package weight, kg',
    'КА SU': 'CA SU',
    'Кол-во контейнеров/машин КА': "Supplier's number of shipping units",
    'Объём, предлагаемый поставщиком': "Supplier's offered volume",
    'KA p.': 'CA p.',
    'Кол-во контейнеров/машин RVI': 'RVI Number of shipping units',
    'Объём RVI': 'RVI Vol.',
    'Объём, предлагаемый RVI': 'RVI offered volume',
    'Объём SU': 'SU Vol.',
    'Объём машина/контейнер': "Shipping unit's volume",
    'Объем RVI': 'RVI Volume',
    'Объем KA': 'KA Volume',
    'Объём КА': 'CA Vol.',
    kap_text: 'CA p.',
    'Вес нетто (машина/контейнер)': 'Net weight (truck/container)',
    'Вес брутто (машина/контейнер)': 'Gross weight (truck/container)',
    product_unit: 'Unit',

    transport_volume: 'The volume (truck/container) kg/pcs',
    transport_volume_from: 'The volume (truck/container) kg/pcs, from',
    transport_volume_to: 'The volume (truck/container) kg/pcs, to',

    import_volume_from: 'RVI Volume, from',
    import_volume_to: 'RVI Volume, to',

    ca_volume_from: 'KA Volume, from',
    ca_volume_to: 'KA Volume, to',

    ca_transport_count_from: 'Number of shipping units, from',
    ca_transport_count_to: 'Number of shipping units, to',

    import_transport_count_from: 'RVI Number of shipping units, from',
    import_transport_count_to: 'RVI Number of shipping units, to',

    tooltipRviSuOrder: 'Number of shipping units',
    'Уважаемые партнёры, портал закрыт. Новая система доступна по адресу importx5.ru':
      'Dear partners, current portal is closed. New portal is available at <0>importx5.ru</0>. Current URL will be redirected to new portal in nearest future. Thank you for being with us!',
    'Объем RVI, шт/кг': 'Volume RVI, psc/kg',

    // OTP
    'Введите код из письма': 'Enter the code from email',
    'Код отправлен на email': 'Code sent to your email',
    '6-значный код': '6-digit code',
    'Введите 6 цифр': 'Enter 6 digits',
    'Код действителен': 'Code is valid for',
    'Время действия кода истекло': 'Code has expired',
    'Проверка...': 'Verifying...',
    'Назад к логину': 'Back to login',
    'Пожалуйста, вернитесь на страницу входа и повторите попытку': 'Please return to the login page and try again',
    'Код неверный или устарел': 'Invalid or expired code',
  },
};
export default enDictionary;
